import {initialCallData} from '../../constants/defaultValues'

import {
	SET_CALL_DATA,
    TOGGLE_CALL_AVAILABILITY
} from '../types'

export default (state = initialCallData, action) => {
    switch (action.type) {
        case SET_CALL_DATA:
            return {
                ...state,
                data: action.payload
            }
        case TOGGLE_CALL_AVAILABILITY:
            return {
                ...state,
                callAvailability: !state.callAvailability
            }
        default:
            return state
    }
}

